import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaCircle } from "react-icons/fa";
import "../../../../assets/css/user/blogs/Blogcard/Blogcard.css";
import tractorblogImg from "../../../../assets/images/home/tractorblog.jpg";
import maintenanceblogImg from "../../../../assets/images/home/maintenanceblog.jpg";
import maintenanceblog1Img from "../../../../assets/images/home/maintenanceblog1.jpg";
import agritechblogImg from "../../../../assets/images/home/agritechblog.jpg";
import agritechblog2Img from "../../../../assets/images/home/agritechblog2.jpg";
import agritechblog3Img from "../../../../assets/images/home/agritechblog3.jpg";
import rentaltipsblogImg from "../../../../assets/images/home/rentaltipblog.jpg";
import userawarenessImg from "../../../../assets/images/home/userawareness.jpg";
import userawareness2Img from "../../../../assets/images/home/userawareness2.jpg";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

// ============================================
// BLOG CARDS COMPONENT
// ============================================
const BlogCard = ({ basePath = "/blog" }) => {
  const navigate = useNavigate();
  const [blogsData, setBlogsData] = useState([]);
  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const handleCardClick = (blogSlug) => {
    navigate(`${basePath}/${blogSlug}`);
  };

  const fetchAllBlogs = () => {
    axios
      .get(`${baseUrl}/customer/blogs/fetchAllBlogs`)
      .then((res) => {
        console.log(res.data);
        if(res.data.success == true){
          setBlogsData(res.data.blogs);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("log from the blog data");
    fetchAllBlogs();
  }, []);

  return (
    <section className="ubc-blog-cards-section">
      <Container>
        <Row className="ubc-blog-cards-grid">
          {blogsData.map((blog) => (
            <Col
              key={blog.id}
              xs={12}
              md={6}
              lg={4}
              className="ubc-blog-card-col"
            >
              <div
                className="ubc-blog-card"
                onClick={() => handleCardClick(blog.slug)}
              >
                {/* Image */}
                <div className="ubc-blog-card-image-wrapper">
                  <img
                    // src={blog.image}
                    src={`${baseUrlForFile}/${blog.image}`}
                    alt={blog.title}
                    className="ubc-blog-card-image"
                  />
                  <div className="ubc-category-badge">{blog.category}</div>
                </div>

                {/* Content */}
                <div className="ubc-blog-card-content">
                  <h3 className="ubc-blog-card-title">{blog.title}</h3>
                  <p className="ubc-blog-card-description">
                    {blog.description}
                  </p>

                  {/* Footer: Status */}
                  <div className="ubc-blog-card-footer">
                    {/* <div className="ubc-status-badge">
                      <FaCircle className="ubc-status-dot" />
                      <span>{blog.status}</span>
                    </div> */}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BlogCard;
